import { Instance, types } from 'mobx-state-tree';
import { AddressRow } from './AddressRow';

export const AddressModuleForm = types.model('AddressModuleForm', {
  rows: types.array(AddressRow),
  hideStreet3: types.maybe(types.boolean)
});
export type AddressModuleForm = Instance<typeof AddressModuleForm>;
